<div class="item" [ngClass]="{ selected: selected }">
  <div class="badge-wrapper">
    <app-product-badge *ngIf="item | isNew" [text]="'general.new' | transloco" priority="primary"> </app-product-badge>
    <app-product-badge *ngIf="item | affiliate: 'hasSalePrice'" [text]="'general.sale' | transloco"
      priority="secondary"></app-product-badge>
  </div>

  <div class="image" (click)="handleHacksClick(item)">
    <img src="{{ item.image180RemotePath | imageSize: '250x250':'webp' }}" loading="lazy" sizes="30vw"
      srcset="{{ item.image180RemotePath | imageSrcSet }}" />
  </div>

  <!-- <app-item-image class="shelf-image" [src]="shelf?.image3dViewPath" size="250x250"> </app-item-image> -->

  <div class="info-box">
    <div class="line1">
      <div class="name">
        {{ item?.name }}
      </div>
      <!--If it is a SALE-->
      <div *ngIf="item | affiliate: 'hasSalePrice'" class="higher-price"
        [innerHTML]="item | affiliate: 'higherPrice' | currencyFormat: 'EUR':'de'"></div>
    </div>
    <div class="line2">
      <div class="manufacturer">
        {{ item?.manufacturer }}
      </div>
      <!--If it is NOT a SALE-->
      <div *ngIf="!(item | affiliate: 'hasSalePrice')" class="higher-price-clear">&nbsp;</div>
      <div *ngIf="!(item | affiliate: 'hasSalePrice')" class="price"
        [innerHTML]="item | affiliate: 'price' | currencyFormat: 'EUR':'de'"></div>
      <!--If it is a SALE-->
      <div *ngIf="item | affiliate: 'hasSalePrice'" class="price info-box-second-line"
        [innerHTML]="item | affiliate: 'price' | currencyFormat: 'EUR':'de'"></div>
    </div>
  </div>
  <div class="actions">
    <ion-button fill="outline" size="small" class="shelfy-primary-btn actions-buttons"
      [ngClass]="{ 'split-mode': splitMode$ | async }" (click)="handleHacksClick(item)">
      {{ 'general.choose' | transloco }}
    </ion-button>

    <!-- ! Keep as reference (click)="handleDetailsClick(shelf)" -->
    <ng-container [ngSwitch]="environment.allowedAffiliates[0]">
      <ion-button *ngSwitchCase="affiliatesEnum.ALL" fill="outline" size="small" [href]="item | affiliate: 'url'"
        target="_blank" class="shelfy-secondary-btn actions-buttons details"
        [ngClass]="{ 'split-mode': splitMode$ | async }">
        {{ 'general.details' | transloco }}
      </ion-button>

      <ion-button *ngSwitchCase="affiliatesEnum.OTTO_DE" fill="clear"
        class="shelfy-secondary-btn actions-buttons details-otto" [ngClass]="{ 'split-mode': splitMode$ | async }"
        size="small" [href]="item | affiliate: 'url'" target="_blank">
        {{ 'general.details' | transloco }}
      </ion-button>
    </ng-container>
  </div>
</div>
